{
  "#PDF_EDITOR": {
    "ASK": {
      "CONFIRM_DELETE": "Möchten Sie die Änderungen wirklich verwerfen?"
    }
  }
}
